import { Component, effect, input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { CustomTableService } from '../../site-table/custom-table/custom-table.service';
import Table from '../../site-table/custom-table/table/Table';
import { getGroupsChange$ } from '../../site-table/table.ui.store';
import Timeline from '../../site-timeline/Timeline';
import { GET_TIMELINE } from '../../site-timeline/timeline.ui.store';
import { bulkGroup } from './bulk-group';
import { bulkUngroup } from './bulk-ungroup';
import { checkIfAllGroupsCollapsed } from './check-if-all-groups-collapsed';

@Component({
  selector: 'pp-bulk-group-button',
  templateUrl: './bulk-group-button.component.html',
  styleUrl: './bulk-group-button.component.scss',
  standalone: false,
})
export class BulkGroupButtonComponent implements OnInit, OnDestroy {
  ppDataFetched = input<boolean>();
  ppType = input<'table' | 'timeline'>();

  EIconPath = EIconPath;
  allCollapsed = false;

  private readonly destroy$ = new Subject<void>();

  constructor(private customTableService: CustomTableService) {
    effect(() => {
      if (this.ppDataFetched()) {
        this.checkIfAllGroupsCollapsed();
      }
    });

    getGroupsChange$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.checkIfAllGroupsCollapsed();
      });
  }

  ngOnInit(): void {
    this.checkIfAllGroupsCollapsed();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  toggleGroups(): void {
    if (this.allCollapsed) {
      this.bulkUngroup();
    } else {
      this.bulkGroup();
    }
  }

  bulkGroup(): void {
    const groupedObject = this.getGroupedObject();

    bulkGroup(groupedObject);
  }

  bulkUngroup(): void {
    const groupedObject = this.getGroupedObject();

    bulkUngroup(groupedObject);
  }

  private checkIfAllGroupsCollapsed(): void {
    const groupedObject = this.getGroupedObject();

    this.allCollapsed = checkIfAllGroupsCollapsed(groupedObject);
  }

  private getGroupedObject(): Table | Timeline {
    return this.ppType() === 'timeline' ? GET_TIMELINE() : this.customTableService.getTable();
  }
}
